import { render } from "./ProjectExplorer.vue?vue&type=template&id=6f04f767"
import script from "./ProjectExplorer.vue?vue&type=script&lang=js"
export * from "./ProjectExplorer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__